import { api } from './client'
import { User, AdminPermissions, UserRole, AdminStats } from '../types'

export async function listUsers(params?: {
  role?: string; search?: string; is_active?: boolean
  offset?: number; limit?: number
}): Promise<User[]> {
  const res = await api.get('/api/v1/users', { params })
  return res.data
}

export async function getUser(id: number): Promise<User> {
  const res = await api.get(`/api/v1/users/${id}`)
  return res.data
}

export async function updateUser(id: number, data: Partial<{
  full_name: string; phone: string; address: string; language: string
}>): Promise<User> {
  const res = await api.patch(`/api/v1/users/${id}`, data)
  return res.data
}

export async function updateMe(data: Partial<{
  full_name: string; phone: string; address: string; language: string
}>): Promise<User> {
  const res = await api.patch('/api/v1/users/me', data)
  return res.data
}

export async function blockUser(id: number, reason: string): Promise<void> {
  await api.post(`/api/v1/users/${id}/block`, { reason })
}

export async function unblockUser(id: number): Promise<void> {
  await api.post(`/api/v1/users/${id}/unblock`)
}

export async function setUserRole(id: number, role: UserRole): Promise<void> {
  await api.post(`/api/v1/users/${id}/role`, { role })
}

export async function getUserPermissions(id: number): Promise<AdminPermissions> {
  const res = await api.get(`/api/v1/users/${id}/permissions`)
  return res.data
}

export async function updatePermissions(
  id: number, data: Partial<AdminPermissions>
): Promise<AdminPermissions> {
  const res = await api.patch(`/api/v1/users/${id}/permissions`, data)
  return res.data
}

export async function applyDiscount(
  id: number, discount_pct: number, reason?: string
): Promise<void> {
  await api.post(`/api/v1/users/${id}/discount`, { discount_pct, reason })
}

export async function removeDiscount(id: number): Promise<void> {
  await api.delete(`/api/v1/users/${id}/discount`)
}

export async function listAdmins(): Promise<User[]> {
  const res = await api.get('/api/v1/manager/admins')
  return res.data
}

export async function promoteToAdmin(telegramId: string): Promise<User> {
  const res = await api.post(`/api/v1/manager/admins/promote/${telegramId}`)
  return res.data
}

export async function demoteAdmin(userId: number): Promise<User> {
  const res = await api.delete(`/api/v1/manager/admins/${userId}`)
  return res.data
}

export async function getAdminStats(userId: number): Promise<AdminStats> {
  const res = await api.get(`/api/v1/manager/admins/${userId}/stats`)
  return res.data
}

export interface UserPayment {
  id: number
  order_id: number
  registry_num?: string
  product_name?: string
  payment_num: number
  amount: number
  paid_amount: number
  due_date: string
  paid_at?: string
  method?: string
}

export async function getUserPayments(params?: { offset?: number; limit?: number }): Promise<UserPayment[]> {
  const res = await api.get('/api/v1/users/me/payments', { params })
  return res.data
}
